<template>
  <div class="row">
    <!-- <div class="col-12 col-lg-8 c g text-center">
      <img src="/assets/images/ad-2026-1-8.jpeg" style="width: 600px;max-width: 100%; height: auto; border-radius: 10px;" alt="Logo">
    </div> -->
    <!-- <div class="col-12 postscontainer" v-if="posts.length">
      <div class="alert alert-info g border">
        <h5>
          آخر الأخبار والتطويرات:
        </h5>
        <ul>
          <template v-for="(post, i) in posts">
            <li v-if="i < 1" :key="post._id">
              <a href="/posts">
                <h4>
                  {{ post.title }}
                  <br>
                  <small>{{ post.short_content }}</small>
                </h4>
              </a>
            </li>
          </template>
        </ul>
        <a href="/posts" class="btn btn-sm btn-success">
        <i class="fa fa-list"></i>
        عرض التفاصيل</a>&nbsp;
        <button class="btn btn-sm btn-outline-danger" @click="hidePosts()">
        <i class="fa fa-eye-slash"></i>
        إخفاء</button>
      </div>
    </div> -->
    <div class="col-12">
      <div class="offer-strip">
        <span class="offer-icon"><i class="fa fa-star"></i></span>
        <div class="offer-text">
          <h4>عروض لفترة محدودة</h4>
          <p>- إشترك الآن في جميع خدمات النظام مقابل سعر مخفض بدلاً من الاشتراك في كل خدمة بشكل منفصل.</p>
          <p>- لفترة محدودة الإشتراك الآن لمدة فصل دراسي بنفس سعر الـ3 أشهر، اشترك الآن قبل انتهاء العرض.</p>
        </div>
        <a href="/offer" class="btn btn-success btn-sm offer-go">للعرض إضغط هنا <i class="fa fa-angle-left"></i></a>
      </div>
    </div>
    <div class="col-12" v-if="!loading && !subscribes.length"><h5 class="alert alert-warning text-center g">
      قم باختيار الخدمة المراد تجربتها او استخدامها من الاسفل <i class="fa fa-arrow-down"></i>
      </h5></div>
    <!-- all services in one table: status, expiry, go / renew / subscribe / trial / details -->
    <div class="col-12">
      <div class="card svc-card">
        <div class="svc-head">
          <div>
            <h4>خدمات النظام</h4>
          </div>
          <div class="svc-tabs" v-if="serviceRows.length">
            <button v-for="t in serviceTabs" :key="t.key" type="button" :class="{ on: svcFilter == t.key }" @click="svcFilter = t.key">
              {{ t.title }} <b>{{ t.count }}</b>
            </button>
          </div>
        </div>
        <div class="text-center g" v-if="loading">
          <img :src="require('@/assets/images/loading.svg')" alt="">
        </div>
        <div class="svc-row svc-labels" v-if="shownRows.length">
          <span>الخدمة</span><span>الحالة</span><span>تاريخ الانتهاء</span><span></span>
        </div>
        <div class="svc-row" v-for="r in shownRows" :key="r.code">
          <div class="svc-name">
            <span class="svc-img"><img :src="require('@/assets/images/gif/'+r.code+'.gif')" alt=""></span>
            <div class="svc-name-text">
              <div class="svc-title">{{ r.title }} <span class="svc-noti" v-if="notis[r.code]">{{ notis[r.code] }}</span></div>
              <div class="svc-bio">{{ r.bio }}</div>
            </div>
          </div>
          <div class="svc-state"><span class="svc-pill" :class="r.pill">{{ r.label }}</span></div>
          <div class="svc-date">
            <template v-if="r.exdate">
              <b dir="ltr">{{ r.exdate }}</b>
              <small :class="r.dueClass">{{ r.due }}</small>
            </template>
            <small v-else>—</small>
          </div>
          <div class="svc-acts">
            <template v-if="r.state == 'active' || r.state == 'trial'">
              <button class="btn btn-sm btn-primary" v-if="checkPer(r.code)" @click="gotoservice(r.code)"><i class="fa fa-angle-left"></i> الذهاب للنظام</button>
              <span v-else></span>
            </template>
            <template v-else-if="r.code == 'bus'">
              <button class="btn btn-sm btn-primary" @click="openbus()"><i class="fa fa-external-link"></i> الذهاب لنظام التوصيل</button>
            </template>
            <template v-else>
              <button class="btn btn-sm btn-success" v-if="checkPer('subscribe')" @click="current = r.service; buy()"><i class="fa fa-refresh" v-if="r.state != 'none'"></i> {{ r.state == 'none' ? 'اشترك الآن' : (r.state == 'expired' ? 'تجديد الاشتراك' : 'اشترك الآن') }}</button>
              <span v-else></span>
            </template>
            <template v-if="checkPer('subscribe') && !(r.code == 'bus' && r.state != 'active' && r.state != 'trial')">
              <button class="btn btn-sm btn-outline-secondary" v-if="r.state == 'active'" @click="current = r.service; buy()"><i class="fa fa-refresh"></i> تجديد</button>
              <button class="btn btn-sm btn-success" v-else-if="r.state == 'trial'" @click="current = r.service; buy()">اشترك الآن</button>
              <button class="btn btn-sm btn-outline-primary" v-else-if="r.state == 'none' && r.service.have_demo == 'yes'" @click="current = r.service; demo(r.code)"><i class="fa fa-play"></i> تجربة مجانية</button>
              <span v-else></span>
            </template>
            <span v-else></span>
            <button class="btn btn-sm btn-secondary" v-b-modal.modal-1 @click="current = r.service"><i class="fa fa-info-circle"></i> التفاصيل</button>
          </div>
        </div>
        <div class="svc-empty" v-if="!loading && serviceRows.length && !shownRows.length">لا توجد خدمات في هذا التصنيف</div>
      </div>
    </div>
    <b-modal id="modal-2" title="ربط بالواتس الذكي" hide-footer>
      <div class="form-group">
        <label for="">رقم الجوال (لتسجيل الدخول في الواتس الذكي)</label>
        <input type="text"
          class="form-control" v-model="whats_phone" placeholder="اكتب هنا...">
      </div>
      <div class="form-group">
        <label for="">كلمة المرور (لتسجيل الدخول في الواتس الذكي)</label>
        <input type="text"
          class="form-control" v-model="whats_password" placeholder="اكتب هنا...">
      </div>
      <div class="col-12 text-center g">
        <button class="btn btn-primary" @click="linkwhats()">
          ربط الان حساب الواتس الذكي
        </button>
      </div>
    </b-modal>  
    <b-modal id="modal-1" title="تفاصيل الخدمة" hide-footer size="lg">
        <div class="row" v-if="current.title">
          <div class="col-12 col-lg-6  c">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div class="me-15 h-50 l-h-60 rounded text-center">
                  <img :src="require('@/assets/images/gif/'+current.code+'.gif')" style="height: 90px; width: 90px !important" alt="">
                </div>
                <div class="d-flex flex-column fw-500 g">
                  <h4>
                    {{ current.title }}
                  </h4>
                  <h5 v-html="current.price">
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 c text-center" v-if="subscribeinfo(current.code).valid && !subscribeinfo(current.code).demo">
            <button class="btn btn-success btn-block btn-lg" @click="gotoservice(current.code)">
              <i class="fa fa-external-link"></i>
              الذهاب لنظام "{{ current.title }}"
            </button>
            ينتهي الاشتراك في: <span dir="ltr">{{ subscribeinfo(current.code).exdate }}</span> <a href="javascript:;" class="btn btn-sm text-primary fa fa-refresh" @click="buy(current.code)"> تجديد</a>
          </div>
          <div class="col-12 col-lg-6 c text-center" v-if="!subscribeinfo(current.code).valid || subscribeinfo(current.code).demo">
            <img :src="require('@/assets/images/loading.svg')" width="50" alt="" v-if="loading">
            <div v-if="!loading && current.code == 'bus'">
              <button class="btn btn-success btn-block" @click="openbus()">
                <i class="fa fa-external-link"></i>
                الذهاب لنظام التوصيل المدرسي
              </button>
            </div>
            <div v-if="!loading && current.code != 'bus'">
              <button class="btn btn-success btn-block btn-lg" @click="buy(current.code)">
                اشتراك الآن في الخدمة
              </button>
              <button class="btn btn-primary btn-block" v-if="!subscribeinfo(current.code).demo && !subscribeinfo(current.code).valid && current.have_demo == 'yes'" @click="demo(current.code)">
                <i class="fa fa-play"></i>
                الحصول على فترة تجريبية
              </button>
              <button class="btn btn-secondary btn-block" v-if="current.code == 'whatsapp'" v-b-modal.modal-2>
                <i class="fa fa-whatsapp"></i>
                ربط بحساب الواتس الذكي
              </button>
              <span class="btn btn-default btn-block" v-if="subscribeinfo(current.code).demo">
                تنتهي التجربة في: <span dir="ltr">{{ subscribeinfo(current.code).exdate }}</span>
              </span>
            </div>
          </div>
          <div class="col-12"><hr></div>
          <div class="col-12" v-html="current.content"></div>
        </div>
    </b-modal>
  </div>
</template>

<script>
import { BDropdown, BDropdownItem } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
export default {
  components: {
    BDropdown,
    BDropdownItem,
  },
  directives: {
    Ripple,
  },
  data(){
    return {
      loading: true,
      user: JSON.parse(localStorage.getItem('user')),
      services: [],
      services_o: {},
      current: {},
      subscribe: {},
      subscribes: [],
      notis: {},
      whats_phone: "",
      whats_password: "",
      posts: [],
      svcFilter: 'all'
    }
  },
  computed: {
    serviceRows(){
      var g = this;
      var rows = [];
      g.services.forEach(function(sv){
        var sub = g.subscribes.find(function(x){ return x.service == sv.code });
        // same visibility as before: sub-accounts see only their subscribed services unless they manage subscriptions
        if(!g.checkPer('subscribe') && !(sub && g.checkPer(sv.code))){ return; }
        var info = g.subscribeinfo(sv.code);
        var state = 'none';
        if(sub){
          state = info.demo ? (info.valid ? 'trial' : 'trial-ended') : (info.valid ? 'active' : 'expired');
        }
        var labels = { active: ['فعّال', 'ok'], trial: ['تجريبي', 'info'], 'trial-ended': ['انتهت التجربة', 'bad'], expired: ['منتهي', 'bad'], none: ['غير مشترك', 'mute'] };
        var due = sub ? g.remainingText(info.exdate) : { text: '', cls: '' };
        rows.push({
          code: sv.code,
          title: sv.title,
          bio: sv.bio,
          service: sv,
          state: state,
          label: labels[state][0],
          pill: labels[state][1],
          exdate: sub ? info.exdate : '',
          due: due.text,
          dueClass: due.cls
        });
      });
      return rows;
    },
    serviceTabs(){
      var rows = this.serviceRows;
      var count = function(f){ return rows.filter(f).length };
      return [
        { key: 'all', title: 'الكل', count: rows.length },
        { key: 'on', title: 'المفعّلة', count: count(function(r){ return r.state == 'active' || r.state == 'trial' }) },
        { key: 'off', title: 'المنتهية', count: count(function(r){ return r.state == 'expired' || r.state == 'trial-ended' }) },
        { key: 'none', title: 'غير مشترك', count: count(function(r){ return r.state == 'none' }) },
      ];
    },
    shownRows(){
      var f = this.svcFilter;
      return this.serviceRows.filter(function(r){
        if(f == 'on'){ return r.state == 'active' || r.state == 'trial' }
        if(f == 'off'){ return r.state == 'expired' || r.state == 'trial-ended' }
        if(f == 'none'){ return r.state == 'none' }
        return true;
      });
    }
  },
  created(){
    var g = this;
    this.loading = true
    $.post(api + '/general/services', {
        jwt: this.user.jwt
    }).then(function(r){
        if(r.status != 100){
            alert(r.response)
        }else{
            g.services = r.response;
            g.services.forEach(function(a){
              g.services_o[a.code] = a
            })
        }
    }).fail(function(){
        g.loading = false
    })
    $.post(api + '/user/general/services-notis', {
        jwt: this.user.jwt
    }).then(function(r){
        if(r.status != 100){
            alert(r.response)
        }else{
            g.notis = r.response
        }
    }).fail(function(){
        g.loading = false
    })
    var treter = setInterval(function(){
      if($(".posts a").length){
        clearInterval(treter)
        setTimeout(() => {
          $.post(api + '/user/general/posts', {
          jwt: g.user.jwt
      }).then(function(r){
          if(r.status != 100){
              alert(r.response)
          }else{
              var nn = 0;
              g.posts = r.response.filter(function(x){
                if(!x.isSeen){
                  return x;
                }else{
                  return false;
                }
              });
              r.response.forEach(function(a){
                if(!a.isSeen){
                  nn = nn + 1;
                }
              })
              if(nn){
                $(".posts a").addClass(`bg-light-danger`)
                $(".posts a").append(`&nbsp;<span class='btn btn-sm btn-danger'>${nn}</span>`)
              }
          }
      }).fail(function(){
          g.loading = false
      })
        }, 1000);
      }
      
    }, 50)
    $.post(api + '/user/subscribe/subscribes', {
        jwt: this.user.jwt
    }).then(function(r){
        g.loading = false
        if(r.status != 100){
            alert(r.response)
        }else{
            g.subscribes = r.response
            if(g.subscribes.length == 0){
              $("#app > div > div.main-menu.menu-fixed.menu-accordion.menu-shadow.expanded.menu-light > ul > ul > li:contains('الخدمات الفعالة')").remove();
              $("#app > div > div.main-menu.menu-fixed.menu-accordion.menu-shadow.expanded.menu-light > ul > ul > li:contains('الصفحات')").remove();
            }
            if($(".sdfsdfsdfsds").length == 0){
            g.subscribes.forEach(function(a){
              if(a.service.includes('العرض')){return;}
              var icon = "star";
              if(a.service == "students"){
                icon = "users"
              }
              if(a.service == "teachers"){
                icon = "user"
              }
              if(a.service == "whatsapp"){
                icon = "whatsapp"
              }
              if(a.service == "results"){
                icon = "paper-plane"
              }
              if(a.service == "calls"){
                icon = "mobile"
              }
              if(a.service == "lessons"){
                icon = "check"
              }
              $(`<li class="nav-item sdfsdfsdfsds"><a href="/_${a.service}" class="d-flex align-items-center">
                <i class='fa fa-${icon}'></i>
                <span class="menu-title text-truncate">${a.title}</span></a></li>`).insertAfter(`#app > div > div.main-menu.menu-fixed.menu-accordion.menu-shadow.expanded.menu-light > ul > ul > li:nth-child(4)`)
              })
            }
        }
    }).fail(function(){
        g.loading = false
    })
  },
  methods: {
    openbus(){
      var g = this;
      window.open(`https://tahdirbus.tahdir.net/login?auto-register&name=${encodeURI(this.user.name)}&phone=${encodeURI(this.user.phone)}&code=tahdir&password=${encodeURI(this.user._id)}`)
    },
    linkwhats(){
      var g = this;
      $.post(api + '/user/whatsapp/link-whats', {
          jwt: this.user.jwt,
          phone: g.whats_phone,
          password: g.whats_password
      }).then(function(r){
          g.loading = false
          if(r.status != 100){
              alert(r.response, 200)
          }else{
              alert("تم الربط بنجاح, قم بـذهاب لخدمة رسائل الواتساب التلقائية الان للتاكد من ربط الجهاز.", 100);
              setTimeout(() => {
                window.location = '/_whatsapp'
              }, 2000);
          }
      }).fail(function(){
        alert("حدث خطأ")
          g.loading = false
      })
    },
    hidePosts(){
      $(".postscontainer").fadeOut('slow')
      var g = this;
      $.post(api + '/user/general/show-posts', {
          jwt: this.user.jwt
      }).then(function(r){
          g.loading = false
          if(r.status != 100){
              alert(r.response, 200)
          }else{
          }
      }).fail(function(){
        alert("حدث خطأ")
          g.loading = false
      })
    },
    remainingText(exdate){
      var days = Math.ceil((new Date(exdate) - new Date()) / 86400000);
      if(isNaN(days)){ return { text: '', cls: '' } }
      var unit = function(n, one, many){ return n >= 3 && n <= 10 ? many : one };
      if(days <= 0){
        return { text: days == 0 ? 'انتهى اليوم' : 'انتهى منذ ' + (-days) + ' ' + unit(-days, 'يوم', 'أيام'), cls: 'bad' };
      }
      if(days <= 30){
        return { text: 'باقي ' + days + ' ' + unit(days, 'يوم', 'أيام'), cls: 'warn' };
      }
      if(days < 365){
        var m = Math.floor(days / 30);
        return { text: 'متبقي ' + m + ' ' + unit(m, 'شهر', 'أشهر'), cls: '' };
      }
      var y = Math.floor(days / 365), mm = Math.floor((days % 365) / 30);
      return { text: 'متبقي ' + y + ' ' + unit(y, 'سنة', 'سنوات') + (mm ? ' و' + mm + ' ' + unit(mm, 'شهر', 'أشهر') : ''), cls: '' };
    },
    subscribeinfo(code){
      var g = this, r = {};
      g.subscribes.forEach(function(a){
        if(a.service == code){
          r = {
            valid: new Date(a?.exdate) > new Date() ? true : false,
            demo: a.demo,
            exdate: a.exdate
          }
        }
      })
      return r;
    },
    gotoservice(id){
      if(this.subscribeinfo(id).valid){
        window.location = '/_' + id
      }else{
         this.$router.push('/expired?service=' + id)
      }
    },
    buy(){
      this.$router.push('/subscribe?code=' + this.current.code)
    },
    demo(code){
      var g = this;
      this.loading = true;
      $.post(api + '/user/subscribe/demo', {
          jwt: this.user.jwt,
          code: this.current.code
      }).then(function(r){
          g.loading = false
          if(r.status != 100){
              alert(r.response)
          }else{
            location.reload()
          }
      }).fail(function(){
          g.loading = false
          alert("حدث خطأ")
      })
    }
  }
}
</script>

<style>
.service{
  transition: transform .2s;
}
.service .card:hover{
  transform: scale(1.05);
  border: 1px solid blue;
  cursor: pointer;
}
.tip{
  text-align: left;
  border: none !important
}
.noti{
  position: absolute;
  top: 0px; 
  right: 0px;
  width: auto;
  font-size: 20px;
  border-radius: 0px 5px 0px 8px;
  filter: drop-shadow(0px 5px 5px #999);
}

</style><style>
/* offer banner + services table (home) */
.offer-strip{
  display: flex;
  align-items: center;
  gap: 16px;
  background: #F0FBF4;
  border: 1px solid #ABEFC6;
  border-radius: 16px;
  padding: 14px 20px;
  margin-bottom: 1.5rem;
}
.offer-icon{
  width: 42px;
  height: 42px;
  flex: none;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: #FEF3C7;
  color: #F5A30B;
  font-size: 18px;
}
.offer-text h4{
  margin: 0 0 2px;
  font-size: 1.1rem;
  font-weight: 800;
  color: #067647;
}
.offer-text p{
  margin: 0;
  color: #344054;
}
.offer-go{
  margin-left: auto;
  flex: none;
}
.svc-card{
  border-radius: 16px;
  overflow: hidden;
}
.svc-head{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
  padding: 18px 22px;
}
.svc-head h4{
  margin: 0;
  font-size: 1.3rem;
  font-weight: 800;
}
.svc-head p{
  margin: 0;
  font-size: .95rem;
  color: #667085;
}
.svc-tabs{
  margin-left: auto;
  display: inline-flex;
  flex-wrap: wrap;
  gap: 2px;
  padding: 4px;
  border-radius: 12px;
  background: #EEF1F6;
}
.svc-tabs button{
  border: 0;
  background: transparent;
  height: 34px;
  padding: 0 13px;
  border-radius: 9px;
  font-weight: 700;
  color: #667085;
  cursor: pointer;
}
.svc-tabs button b{
  font-size: 12px;
  font-weight: 800;
  padding: 1px 6px;
  border-radius: 6px;
  background: rgba(15, 23, 51, .07);
}
.svc-tabs button.on{
  background: #fff;
  color: #0F1733;
  box-shadow: 0 1px 3px rgba(16, 24, 40, .12);
}
.svc-tabs button.on b{
  background: #E8EEFD;
  color: #1E3A8A;
}
.svc-row{
  display: grid;
  grid-template-columns: minmax(0, 1fr) 130px 200px 420px;
  align-items: center;
  gap: 12px;
  padding: 12px 22px;
  border-top: 1px solid #E6E9EF;
}
.svc-row:hover:not(.svc-labels){
  background: #FAFBFD;
}
.svc-labels{
  background: #F6F7FB;
  border-top: 1px solid #D5DAE3;
  border-bottom: 1px solid #D5DAE3;
  padding-top: 9px;
  padding-bottom: 9px;
  font-size: .9rem;
  font-weight: 700;
  color: #667085;
}
.svc-labels + .svc-row{
  border-top: 0;
}
.svc-name{
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.svc-img{
  width: 52px;
  height: 52px;
  flex: none;
  border-radius: 12px;
  background: #F6F7FB;
  display: grid;
  place-items: center;
}
.svc-img img{
  width: 40px;
  height: 40px;
  object-fit: contain;
}
.svc-name-text{
  min-width: 0;
}
.svc-title{
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1.07rem;
  font-weight: 800;
  color: #0F1733;
}
.svc-noti{
  min-width: 22px;
  height: 21px;
  padding: 0 7px;
  border-radius: 11px;
  background: #D92D20;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 21px;
  text-align: center;
}
.svc-bio{
  font-size: .92rem;
  color: #667085;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.svc-pill{
  display: inline-block;
  padding: 3px 11px;
  border-radius: 999px;
  font-size: .9rem;
  font-weight: 700;
  white-space: nowrap;
}
.svc-pill.ok{ background: #DCFAE6; color: #067647; }
.svc-pill.info{ background: #E0F2FE; color: #026AA2; }
.svc-pill.bad{ background: #FEE4E2; color: #B42318; }
.svc-pill.mute{ background: #EEF1F6; color: #667085; }
.svc-date b{
  display: block;
  color: #0F1733;
  font-variant-numeric: tabular-nums;
  text-align: right;
}
.svc-date small{
  display: block;
  font-size: .88rem;
  color: #667085;
}
.svc-date small.warn{ color: #B54708; font-weight: 700; }
.svc-date small.bad{ color: #B42318; font-weight: 700; }
.svc-acts{
  display: grid;
  grid-template-columns: 150px 130px 110px;
  justify-content: end;
  gap: 8px;
}
.svc-acts .btn{
  width: 100%;
  white-space: nowrap;
}
.svc-empty{
  padding: 26px;
  text-align: center;
  color: #667085;
  border-top: 1px solid #E6E9EF;
}
@media (max-width: 1199.98px){
  .svc-row{
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-areas: "name name" "state date" "acts acts";
    gap: 8px 12px;
    padding: 14px 16px;
  }
  .svc-labels{ display: none; }
  .svc-name{ grid-area: name; }
  .svc-state{ grid-area: state; }
  .svc-date{ grid-area: date; text-align: left; }
  .svc-date b{ text-align: left; }
  .svc-acts{ grid-area: acts; grid-template-columns: repeat(3, minmax(0, 1fr)); justify-content: stretch; }
  .svc-tabs{ margin-left: 0; }
  .offer-strip{ flex-wrap: wrap; }
  .offer-go{ margin-left: 0; }
}
@media (max-width: 575.98px){
  .offer-icon{ display: none; }
  .svc-tabs{ flex-wrap: nowrap; overflow-x: auto; max-width: 100%; }
  .svc-tabs button{ flex: none; padding: 0 10px; }
  .svc-acts{ gap: 6px; }
  .svc-acts .btn{ font-size: .82rem; padding-left: .3rem; padding-right: .3rem; }
}
</style>
